// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { citizensProposalsManifest } from './citizens-proposals';
import { billsManifest } from './draft-bills';
import { legislationDesignerManifest } from './legislation-designer';
import { legislationIssuesManifest } from './legislation-issues';
import { plenarySessionsManifest } from './plenary-sessions';
import { resolutionsManifest } from './resolutions';

/** Група модулів «Законотворення» (Legislation): 6 модулів. */
export const legislationGroup: IModuleGroupManifest = {
  key: 'legislation',
  category: 'Legislation',
  name: { en: 'Legislation', uk: 'Законотворення' },
  sort: 13,
  modules: [citizensProposalsManifest, billsManifest, legislationDesignerManifest, legislationIssuesManifest, plenarySessionsManifest, resolutionsManifest],
};
